import BaseService from '../../base/base_service';
import Model from './resize_detector_model';
import DOM from '../../utils/dom';
import Device from '../../utils/device/device';
import _ from '../../utils/underscore';
import Event from '../../utils/event';
import {SYSTEM_EVENTS, USER_EVENTS} from '../../events/events';


/**
 *
 *
 *
 */
class ResizeDetectorService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ResizeDetectorService';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        this._model = Model.create(params);
        this.start();
    }



    /**
     *
     * @public
     */
    start() {
        this.logger.debug('Start resize detector service.');
        let width  = this._model.getWidth(),
            height = this._model.getHeight();
        this
            ._onResizeScreenEventsDetector()
            ._onFullScreenEventsDetector()
            ._responsiveDeviceChange(width)
            ._orientationChanged(width, height)
            ._checkScreenHeight()
            ._checkScreenResolution()
            ._checkMobileOS()
            ._checkIpadDevice()
            ._checkIsAndroid()
            ._checkIphoneVersion()
            ._checkIsHybrid()
            ._checkIsEmbeddedHybrid()
            ._addStyleTagForEvoGames();
    }


    /**
     * Get the current height of the screnn.
     *
     * @returns {*}
     */
    getHeight() {
        return this._model.getHeight();
    }


    /**
     * Get the current width of the screen.
     *
     * @returns {*}
     */
    getWidth() {
        return this._model.getWidth();
    }


    /**
     * Subscribe screen changes events (onresize event and orientationchange).
     *
     *
     * @private
     */
    _onResizeScreenEventsDetector() {
        // Listener for resize width and height change.
        DOM.addEventListener(window, USER_EVENTS.ON_RESIZE, this._onResize.bind(this), false);

        return this;
    }


    /**
     *
     * @private
     */
    _onFullScreenEventsDetector() {
        if (document.addEventListener) {
            DOM.addEventListener(document, 'webkitfullscreenchange', this._onFullScreenChange.bind(this), false);
            DOM.addEventListener(document, 'mozfullscreenchange', this._onFullScreenChange.bind(this), false);
            DOM.addEventListener(document, 'fullscreenchange', this._onFullScreenChange.bind(this), false);
            DOM.addEventListener(document, 'MSFullscreenChange', this._onFullScreenChange.bind(this), false);
        }

        return this;
    }


    /**
     *
     * @private
     */
    _onFullScreenChange() {
        if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null) {
            const fullScreenFlag = _.isFullScreen();
            const fullScreenElem = document.getElementsByClassName('cgp-navbar-game-fullscreen-btn')[0];

                if (!fullScreenFlag) {
                    // Change icon according to screen size state.
                    fullScreenElem.classList.remove('cgp-themes-icons-fullscreen-off');
                    fullScreenElem.classList.add('cgp-themes-icons-fullscreen-on');

                    // Clear screen size.
                    DOM.removeClass(DOM.getHTML(), 'cgp-property-gameframe-anon-size');
                    DOM.removeClass(DOM.getHTML(), 'cgp-property-gameframe-real-size');

                    DOM.removeClass(DOM.getHTML(), 'cgp-full-screen');
                } else {
                    // Change icon according to screen size state.
                    fullScreenElem.classList.remove('cgp-themes-icons-fullscreen-on');
                    fullScreenElem.classList.add('cgp-themes-icons-fullscreen-off');

                    DOM.addClass(DOM.getHTML(), 'cgp-full-screen');
                }

                Event.fire(SYSTEM_EVENTS.FULL_SCREEN_CHANGE, fullScreenFlag);
        }
    }


    /**
     * The current model width and height is the old width and height before the resize the screen.
     *
     * @private
     */
    _onResize() {
        let fireResize = () => {
            this
                ._responsiveDeviceChange()
                ._orientationChanged()
                ._checkScreenHeight()
                ._checkScreenResolution()
                ._addStyleTagForEvoGames();

            Event.fire(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, {
                currentDeviceWidth: Device.viewport.width,
                currentDeviceHeight: Device.viewport.height
            });

            return this;
        };

        /**
         * Patch for all mobile devices to fix the following issues:
         * 1. iOS. Introduced in iOS 10.3.1. window.innerWidth & window.innerHeight are not correct.
         * It happens right after the rotation happens, the values are mixed and width actually returns the hieght!
         * Some point - it's related for a webkit bug rather than iOS.
         * 2. iOS and Android. During orientation process browser fire at least 2 resize events.
         * In some cases DOM manipulation right after the rotation has no effect to UI and cause freeze state.
         * The patch allows device to complete rotation process and prepare correctly for DOM changes from code
         * @see: https://bugs.webkit.org/show_bug.cgi?id=170595 (Bug 170595 - Summary: window.innerWidth/innerHeight are bogus after resize/orientationchange in WKW...)
         * @see: https://github.com/dimsemenov/PhotoSwipe/issues/1315
         * @see: http://www.openradar.me/31725316
         */
        if (Device.os.isMobileOS) {
            [300, 600, 2200].forEach(i => {
                DOM.setTimeout(() => {
                    fireResize();
                }, i);
            });
        }

        return fireResize();
    }


    /**
     * @returns {ResizeDetectorService}
     * @private
     */
    _responsiveDeviceChange() {
        Device.isMobile() ? this._changeResponsiveDevice('mobile', 'pc') : this._changeResponsiveDevice('pc', 'mobile');

        return this;
    }


    /**
     * @private
     */
    _orientationChanged() {
        Device.isPortrait ? this._changeOrientation('portrait', 'landscape') : this._changeOrientation('landscape', 'portrait');

        return this;
    }


    /**
     * Overlay screen change.
     *
     * @returns {ResizeDetectorService}
     * @private
     */
    _overlayChanged() {
        let overlayOnDOM = DOM.$$('.cgp-overlay');

        overlayOnDOM.forEach((overlay) => {
            overlay.style.width = this._model.getWidth() + 'px';
            overlay.style.height = this._model.getHeight() + 'px';
        });

        return this;
    }


    /**
     *
     * @param orientationState
     * @private
     */
    _changeOrientation(addOrientationState, removeOrientationState) {
        if (this._model.getOrientation() === addOrientationState) {
            return;
        }

        // Blur username and password inputs when changing orientation to hide soft keyboard
        let inputText = document.querySelector('input[type="text"]');
        let loginPasswordText = document.querySelector('#cgp-field-password');

        if (inputText) {
            inputText.blur();
        }

        if (loginPasswordText) {
            loginPasswordText.blur();
        }

        this._model.setOrientation(addOrientationState);

        DOM.removeClass(DOM.getHTML(), 'cgp-' + removeOrientationState);
        DOM.addClass(DOM.getHTML(), 'cgp-' + addOrientationState);

        Event.fire(SYSTEM_EVENTS.SCREEN_CHANGE_STATE, addOrientationState);
    }


    /**
     *
     * @param addDeviceType
     * @param removeDeviceType
     * @private
     */
    _changeResponsiveDevice(addDeviceType, removeDeviceType) {
        if (this._model.getDeviceType() === addDeviceType) {
            return;
        }

        this._model.setDeviceType(addDeviceType);

        DOM.removeClass(DOM.getHTML(), 'cgp-' + removeDeviceType);
        DOM.addClass(DOM.getHTML(), 'cgp-' + addDeviceType);

        // Fire device changed event.
        let bodyElem = document.getElementsByTagName('body')[0];

        if (document.createEvent) {
            let eventDetails = document.createEvent('Event');

            eventDetails.initEvent('ondevicechanged', true, true);
            bodyElem.dispatchEvent(eventDetails);
        } else {
            bodyElem.fireEvent('ondevicechanged');
        }


        Event.fire(SYSTEM_EVENTS.SCREEN_CHANGE_STATE, addDeviceType);
    }


    /**
     * Check screen resolution
     *
     * @private
     */
    _checkScreenResolution() {
        const LOW_RESOLUTION_SELECTOR = 'cgp-pc-low-resolution';

        if (Device.os.isPC && Device.viewport.width < 1480) {
            DOM.addClass(DOM.getHTML(), LOW_RESOLUTION_SELECTOR);
        } else {
            DOM.removeClass(DOM.getHTML(), LOW_RESOLUTION_SELECTOR);
        }

        return this;
    }


    /**
     * Check screen height
     *
     * @private
     */
    _checkScreenHeight() {
        const LOW_RESOLUTION_VALUE = 900,
            LOW_HEIGHT_SELECTOR = 'cgp-low-height';

        let windowScreen = Device.viewport.height;

        if (windowScreen <= LOW_RESOLUTION_VALUE) {
            DOM.addClass(DOM.getHTML(), LOW_HEIGHT_SELECTOR);
            return this;
        }

        DOM.removeClass(DOM.getHTML(), LOW_HEIGHT_SELECTOR);
        return this;
    }

    /**
     * detect android os
     * @private
     */
    _checkIsAndroid() {
        if (Device.os.isAndroid) {
            DOM.addClass(DOM.getHTML(), 'cgp-android');
        }
        return this;
    }

    /**
     * detect ipad real device. we need it because ipad in OS 13 don't recognize as mobile.
     */
    _checkIpadDevice() {
        if(Device.isProbablyIPad) {
            DOM.addClass(DOM.getHTML(), 'cgp-ipad-device');
        }

        return this;
    }

    /**
     * Detect mobile operation system - and not mobile OS to detect "fake" mobile(when user shrink the screen on PC)
     * @private
     */
    _checkMobileOS() {
        if (!Device.os.isMobileOS) {
            DOM.addClass(DOM.getHTML(), 'cgp-not-mobile-os'); // @todo: deprecated, should be removed from all code.
        } else {
            DOM.addClass(DOM.getHTML(), 'cgp-real-mobile');
        }

        return this;
    }


    /**
     * Detect iphone version
     * @private
     */
    _checkIphoneVersion() {
        if (Device.model.isIphone) {
            DOM.addClass(DOM.getHTML(), 'cgp-iphone-ver-' + Device.getIphoneVersion());
        }

        return this;
    }


    /**
     * Detect IsHybrid
     * @private
     */
    _checkIsHybrid() {
        if (Device.hybrid.isHybrid) {
            DOM.addClass(DOM.getHTML(), 'cgp-hybrid');
        }

        return this;
    }

    _checkIsEmbeddedHybrid() {
        if (Device.hybrid.isEmbedded) {
            DOM.addClass(DOM.getHTML(), 'cgp-embedded-hybrid');
        }

        return this;
    }

    /**
     * @description Add style tag to the body with the screen height (portrait/landscape) + 1px
     * We add the height + 1px to the body for swipe purposes -This enabled the scroll momentum and then the user be able to minimize the address bar
     * @Note This style will effect the body only when a game is open (cgp-game-open class will be added to the body)
     * @return {ResizeDetectorService}
     * @private
     */
    _addStyleTagForEvoGames(){
        let styleTag;

        if(Device.os.isMobileOS){
            //Calc screen height
            let screenHeight;

            if (Device.viewport.width > Device.viewport.height) {
                screenHeight = Math.min(Device.viewport.screenWidth, Device.viewport.screenHeight);
            } else {
                screenHeight = Math.max(Device.viewport.screenWidth, Device.viewport.screenHeight);
            }

            //We add 1px to the body for Swipe purposes. This enabled to have scroll momentum. (and then the user be able to minimize the address bar)
            let cssClass = `.cgp-mobile body.cgp-game-open.cgp-overlay-open{ height: ${screenHeight + 1}px}`;

            //Check if the style tag already exists - if so remove it before we are adding new one with the updated height
            styleTag  = document.getElementById('cgp-style-game-frame');
            if(styleTag){
                DOM.removeElement(DOM.getBody(), styleTag);
            }

            styleTag = DOM.injectStyleToDOM(cssClass);
            DOM.addAttribute(styleTag, 'id', 'cgp-style-game-frame');
        }

        return this;
    }
}


export default ResizeDetectorService;